"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFreeShippingOfferHandler = addFreeShippingOfferHandler;
exports.dispatchAddFreeShippingOfferFailedEvent = void 0;
var AddFreeShippingOfferFailed = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer-failed"));
var _api = require("../api");
var _logger = require("../logger");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const dispatchAddFreeShippingOfferFailedEvent = detail => {
  const event = new CustomEvent(AddFreeShippingOfferFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchAddFreeShippingOfferFailedEvent = dispatchAddFreeShippingOfferFailedEvent;
async function addFreeShippingOfferHandler({
  detail: {
    itemCode
  }
}, {
  client,
  sessionId,
  tenant
}) {
  try {
    await (0, _api.addShippingOffer)({
      client,
      globalShoppingShippingChoiceDto: {
        itemCode
      },
      sessionId,
      tenant,
      referer: (0, _utils.getReferer)()
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while adding free shipping offer in addFreeShippingOffer event'
    });
    const errorEvent = new CustomEvent(AddFreeShippingOfferFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  const data = await (0, _api.fetchShoppingContextData)();
  if (AddFreeShippingOfferFailed.isAddFreeShippingOfferErrorResponse(data)) {
    const errorEvent = new CustomEvent(AddFreeShippingOfferFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
